import React, { useState } from "react";
import { Button, Image, Modal } from "legion-ui";

const ModalWithImage2 = () => {
  const [isActiveModal4, setIsActiveModal4] = useState(false);
  const modalFooter4 = () => {
    return (
      <div style={{ display: "flex", justifyContent: "right" }}>
        <Button onClick={toggleCustomModal4} css={{ marginRight: "12px" }}>
          Next
        </Button>
      </div>
    );
  };
  const toggleCustomModal4 = () => setIsActiveModal4(!isActiveModal4);
  const closeModal4 = () => {
    if (isActiveModal4) {
      toggleCustomModal4();
    }
  };

  return (
    <React.Fragment>
      <Button onClick={toggleCustomModal4} css={{ marginBottom: "12px" }}>
        More Modal with Image
      </Button>
      <Modal
        isActive={isActiveModal4}
        modalId="legion-modal-4"
        onClose={closeModal4}
        style={{ padding: 0 }}
        footer={modalFooter4()}
        title=" "
        width="700px"
      >
        <Image src="https://www.pandotrip.com/wp-content/uploads/2014/05/Top-10-Arabic-Architecture-Burj-Al-Arab-740x462.jpg" />
        <div style={{ padding: "18px" }}>
          <h3 style={{ textAlign: "center" }}>Modal with Images 2</h3>
          <p>
            This is the modal with custom content, you can pass images, text,
            and customize modal padding. Have a nice try with Legion-ui Modal!
          </p>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ModalWithImage2;
